import { connect } from 'react-redux';
import decorate from '../../../utils/decorate';
import { List } from 'immutable';

import { request as getAvgNetPayouts } from '../../../modules/liabilities/actions/avg-net-payout';

import AvgNetPayout from './AvgNetPayout.jsx';

function mapStateToProps(state) {
    return {
        selections: state.liabilities.getIn([ 'avgNetPayouts', 'items' ]) || List(),
        status: state.liabilities.getIn([ 'avgNetPayouts', 'status' ], 'FINISHED' )
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getAvgNetPayouts() {
            dispatch(getAvgNetPayouts());
        }
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    AvgNetPayout
);
